// ===============================
// 🎨 Tema principal ABIS LP
// ===============================

import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#251101", // Fondo navbar, botones principales y resaltados oscuros
      contrastText: "#FFFBFA", // Texto claro sobre fondos oscuros
    },
    secondary: {
      main: "#45BEC7", // Resaltados importantes (botones, links, hover)
    },
    text: {
      primary: "#000000", // Texto general oscuro (lectura)
      secondary: "#505686", // Color del logo o acentos secundarios
    },
    background: {
      default: "#FFFBFA", // Fondo general del body
      paper: "#FFFFFF",   // Superficies MUI (Dialog, Menu, Paper, Cards)
    },
  },

  components: {
    // ===============================
    // 📄 Base de estilos globales
    // ===============================
    MuiCssBaseline: {
      styleOverrides: {
        "html, body, #root": {
          height: "100%",
          backgroundColor: "#FFFBFA !important",
          color: "#000000 !important",
          fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
          lineHeight: 1.6,
          margin: 0,
          padding: 0,
        },
        a: {
          textDecoration: "none",
          color: "inherit",
        },
      },
    },

    // ===============================
    // 🔘 Botones personalizados
    // ===============================
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: "600",
          borderRadius: "8px",
          transition: "all 0.3s ease",
        },
        containedPrimary: {
          backgroundColor: "#45BEC7",
          color: "#FFFBFA",
          "&:hover": {
            backgroundColor: "#FFFBFA",
            color: "#251101",
            border: "2px solid #45BEC7",
          },
        },
        outlinedPrimary: {
          borderColor: "#45BEC7",
          color: "#45BEC7",
          "&:hover": {
            backgroundColor: "#45BEC7",
            color: "#251101",
          },
        },
      },
    },

    // ===============================
    // 🧾 Tarjetas o secciones (Cards)
    // ===============================
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          "&.hero-titulo": {
            fontSize: "2.8rem",
            fontWeight: 800,
            color: "#505686",
            lineHeight: 1.2,
            marginBottom: "0.3rem",
            textAlign: "left",
            "@media (max-width: 767px)": {
              fontSize: "1.8rem",
              textAlign: "center",
            },
          },
          "&.hero-subtitulo": {
            fontSize: "1.6rem",
            fontWeight: 600,
            color: "#45BEC7",
            lineHeight: 1.3,
            marginBottom: "1rem",
            textAlign: "left",
            "@media (max-width: 767px)": {
              fontSize: "1.2rem",
              textAlign: "center",
            },
          },
          "&.hero-descripcion": {
            fontSize: "1rem",
            color: "#000000",
            maxWidth: "480px",
            lineHeight: 1.7,
            textAlign: "justify",
            "@media (max-width: 767px)": {
              textAlign: "center",
              margin: "0 auto",
            },
          },
        },
      },
    },
  },
});

export default theme;
